export class Cardstatut {
    action: string;
    code: string;
    user: string;
}
